import React from 'react';
import { Bell } from 'lucide-react';
import { badgeText } from './notificationFormat';

interface Props {
    count: number;
    onClick: () => void;
    /** `lg` = 44 px Trefferflaeche fuer den Daumen. */
    size?: 'md' | 'lg';
    className?: string;
}

/** Glocke mit Zaehler (1–9, darueber „9+"). */
export const NotificationBell: React.FC<Props> = ({ count, onClick, size = 'md', className = '' }) => {
    const text = badgeText(count);
    const label = count > 0 ? `Mitteilungen, ${count} ungelesen` : 'Mitteilungen';
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={label}
            title={label}
            className={`relative inline-flex items-center justify-center rounded-lg text-slate-600 hover:bg-slate-100 hover:text-slate-800 active:bg-slate-200 transition-colors ${size === 'lg' ? 'w-11 h-11' : 'w-9 h-9'} ${className}`}
        >
            <Bell className={size === 'lg' ? 'w-5.5 h-5.5' : 'w-5 h-5'} />
            {text && (
                <span className="absolute top-0 right-0 min-w-[20px] h-5 px-1 rounded-full bg-red-600 text-white text-[11px] font-semibold leading-4 text-center tabular border-2 border-white">
                    {text}
                </span>
            )}
        </button>
    );
};
